import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/data/content";

// Reusable CTA band used across pages
export const CtaBand = () => (
  <section className="relative overflow-hidden bg-slate-950 py-24" data-testid="cta-band">
    <img src={IMAGES.portSunset} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
    <div className="absolute inset-0 bg-slate-950/70" />
    <div className="container-x relative z-10">
      <Reveal className="max-w-3xl">
        <span className="eyebrow text-slate-300">Let&apos;s Work Together</span>
        <h2 className="mt-4 text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl text-balance">
          Discuss your requirement with our team.
        </h2>
        <p className="mt-5 text-lg text-slate-300">
          Tell us what you need to source or move — we&apos;ll map out a reliable, end-to-end plan.
        </p>
        <div className="mt-9 flex flex-wrap gap-4">
          <Link
            to="/contact"
            data-testid="ctaband-enquiry"
            className="group inline-flex items-center gap-2 rounded-full bg-[color:var(--brand-red)] px-7 py-3.5 text-base font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5"
          >
            Send an Enquiry
            <ArrowUpRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
          <Link
            to="/solutions"
            className="inline-flex items-center gap-2 rounded-full border border-white/25 px-7 py-3.5 text-base font-semibold text-white transition-colors duration-200 hover:bg-white hover:text-slate-950"
          >
            Explore Our Solutions
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CtaBand;
